export default "__VITE_ASSET__Dh3ryz5H__"